export const generateUrl = (parameters: { [key: string]: string | number }) => {
  const queryStringArray = [];
  for (const key in parameters) {
    if (parameters[key] !== '') {
      queryStringArray.push(`${key}=${encodeURIComponent(parameters[key])}`);
    }
  }

  return `${queryStringArray.join('&')}`;
};
